// stateUtils.js
import allStates from "../data/allstates.json";

export const STATE_TO_FIPS = allStates.reduce((acc, s) => {
    acc[s.id] = s.val; // "TX" -> "48"
    return acc;
}, {});
